import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {Ic, IDesignSolution} from "../../../models/common";
import {getResourceImagePath, isResourceImageAvailable} from "../../../models/view";
import {EDSngMediaService} from "../../edsng-media.service";
import {select} from "@angular-redux/store";
import {appProjectInfo} from "../../../../info.app";
import {support_to_url, Utils} from "../../../common/utils";
import {map} from "rxjs/operators";
import {Observable} from "rxjs";
import {ISpec} from "../../../models/ISpec";
import {AnalyticsActions} from "../../../Redux/Actions/analytics.actions";
import {ActionsService} from "../../../Redux/Actions/actions.service";
import {TTrackingData} from "../../../Redux/Middlewares/analytics";
import { ViewEncapsulation } from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import * as R from "ramda";

@Component({
  selector: "edsng-design-solution-selected",
  encapsulation: ViewEncapsulation.None,
  templateUrl: "./design-solution-selected.component.html",
  styleUrls: [
    "./design-solution-selected.component.css",
    "./design-solution-selected-mobile.component.css"
  ]
})
export class DesignSolutionSelectedComponent implements OnInit {

  public appInfo;
  @select(["appCatalog", "appClass"]) appClass$: Observable<string>;
  @select(['appSpec', 'spec', 'value']) specsVal$: Observable<ISpec<number>>;
  @select(['appContext', 'frameMode']) inFrame$: Observable<boolean>;

  @Input() errorSpecification: boolean = true;
  @Input() designSolution: Ic;
  @Input() enableStart: boolean;
  @Output() closeSelection: EventEmitter<IDesignSolution> = new EventEmitter<IDesignSolution>();
  @Output() openDatasheet: EventEmitter<IDesignSolution> = new EventEmitter<IDesignSolution>();
  @Output() openProductFolder: EventEmitter<IDesignSolution> = new EventEmitter<IDesignSolution>();

  resolution = "md"; // init value waiting for solve isue on ObservableMedia for initial value (beta.9)

  electricalParams$: Observable<{ vin_min?: number; vin_max?: number; vout?: number; iout?: number; power?: number; }>;

  constructor(private media: EDSngMediaService, private actSvc: ActionsService, private translate: TranslateService) {
    this.appInfo = appProjectInfo;

    this.electricalParams$ = this.specsVal$.pipe(
      map(x => ({
        vin_min: Utils.isValueReal(x.input.min) ? x.input.min : undefined,
        vin_max: Utils.isValueReal(x.input.max) ? x.input.max : undefined,
        vout: Utils.isValueReal(x.output.globalOutput.voltage) ? x.output.globalOutput.voltage : undefined,
        iout: Utils.isValueReal(x.output.globalOutput.current) ? x.output.globalOutput.current : undefined,
        power: Utils.isValueReal(x.output.globalOutput.power) ? x.output.globalOutput.power : undefined,
      })));
  }

  sendEvalBoardClick(trackingData: TTrackingData) {
    this.actSvc.sendAction(AnalyticsActions.sendAnalyticsEvent(
      trackingData.hit,
      'redirect',
      {
        cpn: trackingData.cpn,
        rpn: trackingData.rpn ? trackingData.rpn : undefined,
        details: trackingData.details,
        module: trackingData.module ? trackingData.module : undefined,
        topology: trackingData.topology,
        tag: "selected" + (trackingData.tag ? `, ${trackingData.tag}` : '')
      }));
  }
  shareAvailable() {
    // @ts-ignore
    return navigator.share !== undefined;
  }

  ngOnInit() {
    this.media.sizeAlias.subscribe(x => {
      this.resolution = x;
    });
  }

  deselectDesignSolution(): void {
    this.closeSelection.emit(this.designSolution); // deselect
  }

  isSchematicAvailable(): boolean {
    return isResourceImageAvailable(
      this.resolution,
      this.designSolution.schematic
    );
  }

  isAutomotiveGrade(): boolean {
    return R.includes({ feature: {label: 'Automotive Grade'} }, this.designSolution.features);
  }

  getSchematicImage(): string {
    return getResourceImagePath(this.resolution, this.designSolution.schematic);
  }

  isIcPackageAvailable(): boolean {
    return isResourceImageAvailable("xs", this.designSolution.packageImage);
  }

  getPackageImage(): string {
    return getResourceImagePath("xs", this.designSolution.packageImage);
  }

  dsUrl(): string {
    return support_to_url('datasheet', this.translate.currentLang) + this.designSolution.RPN + '.pdf';
  }
  openDS() {
    this.openDatasheet.emit(this.designSolution);
  }

  pfUrl(): string {
    return support_to_url('product_folder', this.translate.currentLang) + this.designSolution.RPN;
  }

  openPF() {
    this.openProductFolder.emit(this.designSolution);
  }

  minNumOutput() {
    return Utils.getFieldValue(this.designSolution, 'designData.minNumOutput', 1);
  }
}
